import { LIST_TRAIL_URL } from "@/student/constants/Urls";

export default {
  state: {
    list:[],
    isLoadingTrails:false,
    selection: [],
    selected_trail_id: null,
  },
  actions: {
    async getTrails({commit, state}) {
        state.isLoadingTrails = true;
        return axios.get(LIST_TRAIL_URL)
          .then(r => {
            commit("SET_TRAILS", r.data.data.map(t=> {
              return {
                selected: false,
                lighten_color: `${t.color}80`,
                ...t
              }
            }));
          })
          .finally(() => {
            state.isLoadingTrails = false;
          });
      }
  },
  mutations: {
    SET_TRAILS(state, payload) {
      state.list = payload;
    },
    SET_SELECTION_BLOCKS(state, payload) {
      state.selection = payload;
    },
    RESET_SELECTED_BLOCKS(state){
      state.list = state.list.map(t=> {
        t.blocks = t.blocks.map(b=> { 
          return {
            ...b,
            selected: false,
          }
        })
        return t
      })
    }
  },
  getters: {
    trails: state => state.list,
    selectedBlocks: (state, getters) => {
      const blocks  = [];
      getters.trails.forEach(t=> t.blocks.filter(b=> b.selected).forEach(b=> blocks.push(b)));
      return blocks
    },
    selectedThemes(state, getters){
      const themes = []
      getters.selectedBlocks.forEach(t=> t.themes.forEach(t => themes.push(t)))
      return themes
    },
    selectedTrailId: state => state.selected_trail_id,
  }
};
